import React from 'react';
import PropTypes from "prop-types";
export var SideNavItem = () => <div />;
SideNavItem.propTypes = {
  /**
     * A value that is passed to React as the `key` for this item
     */
  id: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]).isRequired,

  /**
     * If set to true it will force the item to display in an "open" state at all times.
     */
  forceOpen: PropTypes.bool,

  /**
     * Is an optional string to be passed as the navigation item's `href` prop, and by default it will force rendering of the item as an `<a>`.
     */
  href: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,

  /**
     * React node which will be rendered as a small icon to the left of the navigation item text.
     */
  icon: PropTypes.element,

  /**
     * If set to true it will render the item in a visible "selected" state, and will force all ancestor navigation items to render in an "open" state.
     */
  isSelected: PropTypes.bool,

  /**
     * Array containing additional item objects, representing nested children of this navigation item.
     */
  items: PropTypes.arrayOf(PropTypes.shape({
    /**
       * A value that is passed to React as the `key` for this item
       */
    id: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]).isRequired,

    /**
       * If set to true it will force the item to display in an "open" state at all times.
       */
    forceOpen: PropTypes.bool,

    /**
       * Is an optional string to be passed as the navigation item's `href` prop, and by default it will force rendering of the item as an `<a>`.
       */
    href: PropTypes.string,
    target: PropTypes.string,
    rel: PropTypes.string,

    /**
       * React node which will be rendered as a small icon to the left of the navigation item text.
       */
    icon: PropTypes.element,

    /**
       * If set to true it will render the item in a visible "selected" state, and will force all ancestor navigation items to render in an "open" state.
       */
    isSelected: PropTypes.bool,

    /**
       * Array containing additional item objects, representing nested children of this navigation item.
       */
    items: PropTypes.arrayOf(PropTypes.any.isRequired),

    /**
       * React node representing the text to render for this item (usually a string will suffice).
       */
    name: PropTypes.node.isRequired,

    /**
       * Callback function to be passed as the navigation item's `onClick` prop, and by default it will force rendering of the item as a `<button>` instead of a link.
       */
    onClick: PropTypes.func,

    /**
       * Function overriding default rendering for this navigation item — when called, it should return a React node representing a replacement navigation item.
       */
    renderItem: PropTypes.func
  }).isRequired),

  /**
     * React node representing the text to render for this item (usually a string will suffice).
     */
  name: PropTypes.node.isRequired,

  /**
     * Callback function to be passed as the navigation item's `onClick` prop, and by default it will force rendering of the item as a `<button>` instead of a link.
     */
  onClick: PropTypes.func,

  /**
     * Function overriding default rendering for this navigation item — when called, it should return a React node representing a replacement navigation item.
     */
  renderItem: PropTypes.func
};

try {
  // @ts-ignore
  SideNavItem.displayName = "SideNavItem"; // @ts-ignore

  SideNavItem.__docgenInfo = {
    "description": "",
    "displayName": "SideNavItem",
    "props": {
      "id": {
        "defaultValue": null,
        "description": "A value that is passed to React as the `key` for this item",
        "name": "id",
        "required": true,
        "type": {
          "name": "ReactText"
        }
      },
      "forceOpen": {
        "defaultValue": null,
        "description": "If set to true it will force the item to display in an \"open\" state at all times.",
        "name": "forceOpen",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "href": {
        "defaultValue": null,
        "description": "Is an optional string to be passed as the navigation item's `href` prop, and by default it will force rendering of the item as an `<a>`.",
        "name": "href",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "target": {
        "defaultValue": null,
        "description": "",
        "name": "target",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "rel": {
        "defaultValue": null,
        "description": "",
        "name": "rel",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "icon": {
        "defaultValue": null,
        "description": "React node which will be rendered as a small icon to the left of the navigation item text.",
        "name": "icon",
        "required": false,
        "type": {
          "name": "ReactElement<any, string | ((props: any) => ReactElement<any, string | ... | (new (props: any) => Component<any, any, any>)> | null) | (new (props: any) => Component<any, any, any>)> | undefined"
        }
      },
      "isSelected": {
        "defaultValue": null,
        "description": "If set to true it will render the item in a visible \"selected\" state, and will force all ancestor navigation items to render in an \"open\" state.",
        "name": "isSelected",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "items": {
        "defaultValue": null,
        "description": "Array containing additional item objects, representing nested children of this navigation item.",
        "name": "items",
        "required": false,
        "type": {
          "name": "EuiSideNavItemType<any>[] | undefined"
        }
      },
      "name": {
        "defaultValue": null,
        "description": "React node representing the text to render for this item (usually a string will suffice).",
        "name": "name",
        "required": true,
        "type": {
          "name": "ReactNode"
        }
      },
      "onClick": {
        "defaultValue": null,
        "description": "Callback function to be passed as the navigation item's `onClick` prop, and by default it will force rendering of the item as a `<button>` instead of a link.",
        "name": "onClick",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLButtonElement, MouseEvent>) => void) | undefined"
        }
      },
      "renderItem": {
        "defaultValue": null,
        "description": "Function overriding default rendering for this navigation item \u2014 when called, it should return a React node representing a replacement navigation item.",
        "name": "renderItem",
        "required": false,
        "type": {
          "name": "RenderItem<any> | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src-docs/src/views/side_nav/props.tsx#SideNavItem"] = {
      docgenInfo: SideNavItem.__docgenInfo,
      name: "SideNavItem",
      path: "src-docs/src/views/side_nav/props.tsx#SideNavItem"
    };
} catch (__react_docgen_typescript_loader_error) {}